module.exports = __webpack_public_path__ + "img/pp_17.1334df58.png";